export const AMEX_CARD_CHECKER = /^3[47]\d{1,13}$/
export const MAESTRO_CARD_CHECKER = /^(?:5[0678]\d\d|6304|6390|67\d\d)\d{8,15}$/
export const OMNIO_CARD_CHECKER = /^40006506\d{8}$/

export  const getCleanedCardNumber = (cardNumber) => cardNumber?.replace(/\s/g, '')
